"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
var fingerprintjs_1 = __importDefault(require("@fingerprintjs/fingerprintjs"));
var Navigation_1 = require("../../components/Navigation");
var axios_1 = __importDefault(require("../../utils/axios"));
var actions_1 = require("../../store/auth/actions");
require("react-phone-input-2/lib/style.css");
require("./login.scss");
var hooks_1 = require("../../hooks");
var store_1 = require("../../store/store");
var react_toastify_1 = require("react-toastify");
var Spinner_1 = __importDefault(require("react-activity/dist/Spinner"));
var react_router_1 = require("react-router");
var AuthType;
(function (AuthType) {
    AuthType["login"] = "login";
    AuthType["registration"] = "registration";
})(AuthType || (AuthType = {}));
var platform = 'desktop';
var app_v = '1.0.0';
var platform_v = '1.0.0';
var fpPromise = fingerprintjs_1.default.load();
exports.default = (function (props) {
    var location = (0, react_router_1.useLocation)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(''), phone = _a[0], setPhone = _a[1];
    var _b = (0, react_1.useState)(), type = _b[0], setType = _b[1];
    var _c = (0, react_1.useState)(''), code = _c[0], setCode = _c[1];
    var _d = (0, react_1.useState)(''), name = _d[0], setName = _d[1];
    var _e = (0, react_1.useState)(''), email = _e[0], setEmail = _e[1];
    var setToken = (0, hooks_1.useToken)().setToken;
    var _f = (0, react_redux_1.useSelector)(function (state) {
        var _a, _b;
        return ({
            chain_id: state.restaurant.restaurant.chain_id,
            loading: state.auth.loading,
            privacy: (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.privacy,
            terms: (_b = state.app.chain) === null || _b === void 0 ? void 0 : _b.terms,
        });
    }), chain_id = _f.chain_id, loading = _f.loading, privacy = _f.privacy, terms = _f.terms;
    var restaurant = props.match.params.restaurant;
    var onLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fp, result, data, response, e_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch((0, actions_1.loginRequest)());
                    return [4, fpPromise];
                case 1:
                    fp = _b.sent();
                    return [4, fp.get()];
                case 2:
                    result = _b.sent();
                    data = {
                        code: code,
                        phone: phone,
                        name: name,
                        email: email,
                        chain_id: chain_id,
                        device_id: result.visitorId || 'no',
                        device_model: navigator.userAgent,
                        app_v: app_v,
                        platform: platform,
                        platform_v: platform_v,
                        bundle: '',
                    };
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 6, , 7]);
                    return [4, axios_1.default.post('/api/auth', data)];
                case 4:
                    response = _b.sent();
                    return [4, setToken(response.data.token)];
                case 5:
                    _b.sent();
                    dispatch((0, actions_1.loginSuccess)(response.data.client, response.data.token));
                    store_1.history.push({
                        pathname: "/store/".concat(restaurant, "/checkout"),
                        search: location.search
                    });
                    return [3, 7];
                case 6:
                    e_1 = _b.sent();
                    message = ((_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _a === void 0 ? void 0 : _a.message) || (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || 'Something went wrong';
                    dispatch((0, actions_1.loginFailure)(e_1));
                    react_toastify_1.toast.error(message);
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); };
    var onGetCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, response, e_2, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch((0, actions_1.getCodeRequest)());
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    data = {
                        phone: phone,
                        chain_id: chain_id
                    };
                    return [4, axios_1.default.post('/api/code', data)];
                case 2:
                    response = _b.sent();
                    if (response.data.message == 'ok' && (response.data.type == AuthType.login || response.data.type == AuthType.registration)) {
                        setType(response.data.type);
                        dispatch((0, actions_1.getCodeSuccess)());
                    }
                    else {
                        throw Error('unknown');
                    }
                    return [3, 4];
                case 3:
                    e_2 = _b.sent();
                    message = ((_a = e_2 === null || e_2 === void 0 ? void 0 : e_2.data) === null || _a === void 0 ? void 0 : _a.message) || (e_2 === null || e_2 === void 0 ? void 0 : e_2.message) || 'Something went wrong';
                    dispatch((0, actions_1.getCodeFailure)());
                    react_toastify_1.toast.error(message);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var onPress = function () {
        switch (type) {
            case AuthType.login: return onLogin();
            case AuthType.registration: return onLogin();
            default: return onGetCode();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Navigation_1.Navigation, { hideBasket: true }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "login-container" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "login" }, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ action: "#", className: "login-form" }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: "Sign In" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "email", className: "login-row-title" }, { children: "Phone number" })), (0, jsx_runtime_1.jsx)(react_phone_input_2_1.default, { inputClass: "login-row-input", country: 'gb', value: phone, onChange: function (phone) { return setPhone("+".concat(phone)); } })] })), type == AuthType.login || type == AuthType.registration ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "email", className: "login-row-title" }, { children: "Code" })), (0, jsx_runtime_1.jsx)("input", { className: "login-row-input form-control", value: code, onChange: function (e) { return setCode(e.target.value); } })] }))) : null, type == AuthType.registration ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "email", className: "login-row-title" }, { children: "Name" })), (0, jsx_runtime_1.jsx)("input", { className: "login-row-input form-control", value: name, onChange: function (e) { return setName(e.target.value); } })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "email", className: "login-row-title" }, { children: "Email" })), (0, jsx_runtime_1.jsx)("input", { className: "login-row-input form-control", value: email, onChange: function (e) { return setEmail(e.target.value); } })] }))] })) : null, (0, jsx_runtime_1.jsx)("div", __assign({ className: "basket-total-button-wrap" }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ disabled: loading, onClick: onPress, className: "basket-total-button" }, { children: loading ? (0, jsx_runtime_1.jsx)(Spinner_1.default, { size: 10 }) : "Continue" })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "agreement" }, { children: [(0, jsx_runtime_1.jsx)("div", { children: "By continuing you are agreeing to our\u00A0" }), (0, jsx_runtime_1.jsx)("a", __assign({ href: privacy }, { children: "Privacy Policy" })), " and ", (0, jsx_runtime_1.jsx)("a", __assign({ href: terms }, { children: "Terms and Conditions" }))] }))] })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "basket-controls" }, { children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("button", __assign({ className: "basket-total-button", onClick: onPress }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "controls-order-title" }, { children: loading ? (0, jsx_runtime_1.jsx)(Spinner_1.default, { size: 10 }) : "Continue" })) }))] }))] }))] }));
});
